import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  // Public route kontrolü
  const publicRoutes = ['/pastel', '/cari/', '/login'];
  const isPublicRoute = publicRoutes.some(route => {
    if (route === '/cari/') {
      return location.pathname.startsWith('/cari/');
    }
    return location.pathname === route || location.pathname.startsWith(route);
  });

  // Public route'larda hiçbir kontrol yapma, direkt render et
  if (isPublicRoute) {
    return children;
  }

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto"></div>
          <p className="mt-4 text-gray-600 dark:text-gray-400">Yükleniyor...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
